import { type MaybeRef, computed, unref, watchEffect } from 'vue';
import useViewTitle from './useViewTitle';

export default (viewName: MaybeRef<string>) => {
  const fullViewName = computed(() => `${unref(viewName)} | User`);
  const { patch } = useViewTitle(fullViewName);

  watchEffect(() => {
    patch({
      title: fullViewName.value,
    });
  });
};
